import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 5px; 
  color: ${({ theme }) => theme?.colors?.common?.white};
`;

export const TimeDisplay = styled.span`
  color: ${({ theme }) => theme?.colors?.common?.white};
  font-size: 14px;
  display: inline-block;
`;

export const SVGComponent = styled.svg`
  width: 24px;
  height: 24px;
`;
